import { render, staticRenderFns } from "./TenantEnd.vue?vue&type=template&id=65447dff&"
import script from "./TenantEnd.vue?vue&type=script&lang=js&"
export * from "./TenantEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports